import React, { JSX } from "react";
import { Box, Typography } from "@mui/material";
import { scaleFont } from "../LabPrintFunctions";
import { Settings } from "../../../../interfaces/ResourceCentreInterface";

export interface ResourceCentre {
  resourceCentreLogo?: any;
  name: string;
  slogan: string | null;
  address: string;
  city: string;
  registrationNumber: string;
  phone: string;
  mobileNumber: string;
  optionalPhone: string | null;
  web: string | null;
  email: string;
  panNo: number | null;
  settings: Settings;
  phone2: string;
}

interface LabPrintLetterHeadProps {
  resourceCentre: ResourceCentre;
  titleFontScale: number;
  hideRcLogo?: boolean;
  additionalContent?: JSX.Element;
}

const LabPrintLetterHead: React.FC<LabPrintLetterHeadProps> = ({
  resourceCentre: {
    resourceCentreLogo,
    name,
    slogan,
    address,
    city,
    registrationNumber,
    phone,
    phone2,
    mobileNumber,
    optionalPhone,
    web,
    email,
    panNo
  },
  titleFontScale = 1,
  hideRcLogo = false,
  additionalContent
}) => (
  <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
    <Box sx={{ display: "flex" }}>
      {!hideRcLogo && resourceCentreLogo && (
        <Box sx={{ mt: "8px" }}>
          <img
            src={resourceCentreLogo.s3ResourceURL}
            className="billLogo"
            alt="logo"
            style={{ width: "auto", height: "84px" }}
          />
        </Box>
      )}
      <Box sx={{ pl: resourceCentreLogo && !hideRcLogo ? 2 : 0 }}>
        <Typography sx={{ fontWeight: 500, fontSize: scaleFont("0.6cm", titleFontScale) }}>
          {name}
        </Typography>
        {slogan && <Typography sx={{ fontSize: "0.35cm", fontWeight: 400 }}>{slogan}</Typography>}
        <Typography sx={{ textAlign: "left", textTransform: "capitalize", fontSize: "0.325cm" }}>
          {address} {city}
        </Typography>
        {registrationNumber && (
          <Typography sx={{ textAlign: "left", textTransform: "capitalize", fontSize: "0.325cm" }}>
            Reg No: {registrationNumber}
          </Typography>
        )}
      </Box>
    </Box>
    <Box>
      <Typography sx={{ textAlign: "right", fontSize: "0.325cm" }}>
        {mobileNumber || ""} {optionalPhone && `,${optionalPhone}`}
      </Typography>
      <Typography sx={{ textAlign: "right", fontSize: "0.325cm" }}>
        {phone} {phone2 && `,${phone2}`}
      </Typography>
      <Typography sx={{ textAlign: "right", fontSize: "0.325cm" }}>{web || ""}</Typography>
      <Typography sx={{ textAlign: "right", fontSize: "0.325cm" }}>{email || ""}</Typography>
      {Boolean(panNo) && (
        <Typography sx={{ textAlign: "right", fontSize: "0.325cm" }}>Pan No: {panNo}</Typography>
      )}
      {additionalContent && additionalContent}
    </Box>
  </Box>
);

export default LabPrintLetterHead;
